import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
} from '@microsoft/signalr'
import { base, event } from './interface/baseInterface'
import { readMessage } from '../chat/inerface/iterface'

export class BaseChat {
  private static instance: BaseChat | null = null
  serverUrl: string
  connection?: HubConnection
  events: event[]
  connectionFailed: Function
  connectionStartFailed: Function
  close: Function
  reConnected: Function
  reConnecting: Function
  stop: Function




  private constructor(
    serverUrl: string,
    events: event[],
    connectionFailed: Function,
    connectionStartFailed: Function,
    close: Function,
    stop: Function,
    reConnected: Function,
    reconnecting: Function,

  ) {
    this.events = events
    this.connectionFailed = connectionFailed
    this.connectionStartFailed = connectionStartFailed
    this.serverUrl = serverUrl
    this.close = close
    this.reConnected = reConnected
    this.reConnecting = reconnecting
    this.stop = stop
    this.configConnection()

  }

  public static getInstance(
    serverUrl: string,
    events: event[],
    connectionFailed: Function,
    connectionStartFailed: Function,
    close: Function,
    reconnnection: Function,
    reconnecting: Function,
    stop: Function
  ): BaseChat {
    if (this.instance === null) {
      this.instance = new BaseChat(
        serverUrl,
        events,
        connectionFailed,
        connectionStartFailed,
        close,
        reconnnection,
        reconnecting,
        stop,


      )
    }
    return this.instance
  }

  private configConnection() {
    let connection = new HubConnectionBuilder()
      .withUrl(this.serverUrl, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect([0, 3000, 5000, 7000])
      .configureLogging(2)
      .build()
    this.connection = connection
    this.connection.onclose(() => this.close())
    this.connection.onreconnecting(() => this.reConnecting())
    this.connection.onreconnected(() => this.reConnected())
  }
  public getState() {
    return this.connection?.state
  }
  startConnection() {

    console.log("this.connection?.state ", this.connection?.state)
    this.connection && this.connection
      .start()
      .then(() => {
        console.log('The hub connection status...', this.connection?.state)
        console.log('events', this.events)
        this.events.map((item: event) => {
          this.connection?.on(item.name!, (result: base) => {
            item.callBack(result)
          })
        })
      })
      .catch((e: any) => this.connectionStartFailed(e))

  }

  stopConnection() {

    if (this.connection?.state === "Connected") {
      this.connection.stop().then(() => {
      }).catch((err) => {
        console.log("errrorr", err)
      })

    }
  }




  send<T>(methodName: string, ...arg: any[]): Promise<T> {
    return new Promise<any>((resolve, reject) => {

      if (this.connection && this.connection?.state.toString() === "Connected") {
        try {
          if (this.connection?.state === HubConnectionState.Connected) {
            if (arg === null || arg === undefined) {
              this.connection
                ?.invoke(methodName)
                .then((data: any) => {
                  resolve({
                    result: 'ok',
                    message: `Method ${methodName} successfull when client has sent to server`,
                  })
                })
                .catch((err: any) => {
                  reject({ result: 'error', message: err })
                })
            } else {
              this.connection
                ?.invoke<T>(methodName, ...arg)
                .then((data: any) => {
                  resolve({
                    result: 'ok',
                    message: `Method ${methodName} successfull when client has sent to server`,
                  })
                })
                .catch((err: any) => {
                  reject({ result: 'error', message: err })
                })
            }
          } else {
            reject({
              result: 'error',
              message: `Method ${methodName} failed when client has sent to server . The hub connection ${this.connection?.state}...`,
            })
          }
        } catch {
          reject({
            result: 'error',
            message: `Method ${methodName} failed when client has sent to server.`,
          })
        }
      }
    })
  }

  getUserOpenChat<T>(userId: string, tenantId: string, type: number): Promise<T> {
    return new Promise<any>((resolve, reject) => {
      try {
        if (this.connection?.state === HubConnectionState.Connected) {
          this.connection
            ?.invoke("GetUserOpenChatWithTenantId", userId, tenantId, type)
            .then((data: any) => {
              resolve({
                result: 'ok',
                message: `Method GetUserOpenChat successfull when client has sent to server`,
              })
            })
            .catch((err: any) => {
              reject({ result: 'error', message: err })
            })

        } else {
          reject({
            result: 'error',
            message: `Method GetUserOpenChat failed when client has sent to server . The hub connection ${this.connection?.state}...`,
          })
        }
      } catch {
        reject({
          result: 'error',
          message: `Method GetUserOpenChat failed when client has sent to server.`,
        })
      }
    })
  }

  getChatMessagesWithChatIdAndMessageId<T>(readMessage: readMessage): Promise<T> {
    return new Promise<any>((resolve, reject) => {
      try {
        if (this.connection?.state === HubConnectionState.Connected) {
          this.connection
            ?.invoke("GetChatMessagesWithChatIdAndMessageId", readMessage)
            .then((data: any) => {
              resolve({
                result: 'ok',
                message: `Method GetChatMessagesWithChatIdAndMessageId successfull when client has sent to server`,
              })
            })
            .catch((err: any) => {
              reject({ result: 'error', message: err })
            })

        } else {
          reject({
            result: 'error',
            message: `Method GetChatMessagesWithChatIdAndMessageId failed when client has sent to server . The hub connection ${this.connection?.state}...`,
          })
        }
      } catch {
        reject({
          result: 'error',
          message: `Method GetChatMessagesWithChatIdAndMessageId failed when client has sent to server.`,
        })
      }
    })
  }
}




